import React from 'react';

interface EarningsDashboardProps {
  storeData: any;
}

const EarningsDashboard: React.FC<EarningsDashboardProps> = ({ storeData }) => {
  return (
    <div style={{ color: 'white', padding: '40px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px' }}>Earnings Dashboard</h1>
      <p style={{ color: 'rgba(255,255,255,0.7)' }}>
        💰 Earnings tracking, payment history & analytics coming soon!
      </p>
    </div>
  );
};

export default EarningsDashboard;
